import './dashboard.css';

import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import React from 'react';

import { AccountButton } from './account-button/account-button';
import { LibrarySelection } from './library-selection';
import { MindmapCard } from './mindmap-card';

export const Dashboard = () => {
  return (
    <>
      <header>
        <div className="flex justify-content-between pt-4 fullscreen-container">
          <Button label="Mindmap erstellen" icon="pi pi-plus" className="p-button-rounded p-button-secondary" />
          <LibrarySelection />
          <div>
            <AccountButton />
          </div>
        </div>
        <Divider />
      </header>
      <div className="fullscreen-container">
        <div id="grid">
          {new Array(120).fill(2).map((v, i) => (
            <MindmapCard key={i} />
          ))}
        </div>
      </div>
    </>
  );
};
